
import React, {
    createContext,
    useContext,
    useEffect,
    useState,
} from "react";

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
    const [mode, setMode] = useState(() => {
        const savedTheme = localStorage.getItem("theme");

        return savedTheme === "light" ? "light" : "dark";
    });

    const isDark = mode === "dark";

    useEffect(() => {
        localStorage.setItem("theme", mode);

        document.documentElement.dataset.theme = mode;
        document.documentElement.classList.toggle("dark", isDark);
    }, [mode, isDark]);

    const toggleTheme = () => {
        setMode((prev) =>
            prev === "dark" ? "light" : "dark"
        );
    };

    return (
        <ThemeContext.Provider
            value={{
                mode,
                isDark,
                toggleTheme,
                setTheme: setMode,
            }}
        >
            {children}
        </ThemeContext.Provider>
    );
};

export const useAppTheme = () => {
    const context = useContext(ThemeContext);

    if (!context) {
        throw new Error(
            "useAppTheme must be used within ThemeProvider"
        );
    }

    return context;
};
